module.exports = __webpack_public_path__ + "img/icon2.91ff658a.png";